import { render, staticRenderFns } from "./NewPost.vue?vue&type=template&id=10b17a0e&scoped=true"
import script from "./NewPost.vue?vue&type=script&lang=js"
export * from "./NewPost.vue?vue&type=script&lang=js"
import style0 from "./NewPost.vue?vue&type=style&index=0&id=10b17a0e&prod&scoped=true&lang=css"
import style1 from "./NewPost.vue?vue&type=style&index=1&id=10b17a0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b17a0e",
  null
  
)

export default component.exports